export const signatureBurgers = [
  {
    id: 'original',
    no: '01',
    name: 'The Original',
    price: '$12',
    tag: 'best seller',
    desc: 'Double smash patty, American cheese, pickles, house sauce.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/46b3cb2df3e9774c2f64255192a14470/0ba43c55-3dd5-4419-bd54-30933f4086f0_88f3ac66.webp',
    cutout: true,
  },
  {
    id: 'hot-one',
    no: '02',
    name: 'The Hot One',
    price: '$14',
    tag: 'spicy!',
    desc: 'Charred jalapeños, pepper jack, hot honey, chili mayo.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/46b3cb2df3e9774c2f64255192a14470/0ba43c55-3dd5-4419-bd54-30933f4086f0_4499711d.webp',
    cutout: true,
  },
  {
    id: 'smokehouse',
    no: '03',
    name: 'The Smokehouse',
    price: '$15',
    tag: 'chef pick',
    desc: 'Smoked bacon, caramelized onion, sharp cheddar, BBQ glaze.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/46b3cb2df3e9774c2f64255192a14470/0ba43c55-3dd5-4419-bd54-30933f4086f0_7290e6fe.webp',
    cutout: true,
  },
  {
    id: 'fire-fries',
    no: '04',
    name: 'Loaded Fire Fries',
    price: '$8',
    tag: 'share it',
    desc: 'Sea-salt fries, cheese sauce, chili flakes, pickled jalapeños.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/46b3cb2df3e9774c2f64255192a14470/0ba43c55-3dd5-4419-bd54-30933f4086f0_445507e6.webp',
    cutout: true,
  },
  {
    id: 'onion-rings',
    no: '05',
    name: 'Crispy Onion Rings',
    price: '$6',
    tag: 'crunch',
    desc: 'Beer-battered sweet onion, smoky dip on the side.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/46b3cb2df3e9774c2f64255192a14470/0ba43c55-3dd5-4419-bd54-30933f4086f0_786bbc13.webp',
    cutout: true,
  },
  {
    id: 'vanilla-shake',
    no: '06',
    name: 'Vanilla Shake',
    price: '$7',
    tag: 'cool down',
    desc: 'Thick vanilla soft-serve, whipped cream, a cherry on top.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/46b3cb2df3e9774c2f64255192a14470/0ba43c55-3dd5-4419-bd54-30933f4086f0_5b001805.webp',
    cutout: true,
  },
];

export const menuMoreCard = {
  title: 'See the whole menu',
  body: 'Burgers, grill, sides & shakes — every category in one place.',
  cta: 'Browse categories',
};

export const fullMenu = [
  {
    group: 'Burgers',
    items: [
      { name: 'The Original', price: '$12' },
      { name: 'The Hot One', price: '$14' },
      { name: 'The Smokehouse', price: '$15' },
      { name: 'Single Smash', price: '$9' },
      { name: 'Veggie Smash', price: '$12' },
    ],
  },
  {
    group: 'From the Grill',
    items: [
      { name: 'Charcoal Chicken Thighs', price: '$13' },
      { name: 'Grilled Sausage Dog', price: '$10' },
      { name: 'Flame Corn, Chili Butter', price: '$6' },
    ],
  },
  {
    group: 'Sides & Drinks',
    items: [
      { name: 'Fries, Sea Salt', price: '$5' },
      { name: 'Loaded Fire Fries', price: '$8' },
      { name: 'Vanilla Shake', price: '$7' },
      { name: 'House Lemonade', price: '$4' },
    ],
  },
];

export const layers = [
  { no: '01', name: 'Toasted Brioche', note: 'Butter-griddled, soft centre' },
  { no: '02', name: 'House Sauce', note: 'Tangy, smoky, secret' },
  { no: '03', name: 'Pickles & Onion', note: 'Sharp crunch, raw bite' },
  { no: '04', name: 'American Cheese', note: 'Melted over the patty' },
  { no: '05', name: 'Smashed Beef', note: 'Chuck & brisket, lacy edges' },
  { no: '06', name: 'Second Patty', note: 'Because one is not enough' },
  { no: '07', name: 'Bottom Bun', note: 'Built to hold the mess' },
];